module.exports = __webpack_public_path__ + "videos/msu-video.250860c.mp4";